export enum enumSystemPolicyType {
    OnlinePayment = 1,
    OrderContent = 2,
    StockControl = 3,
    MetalPrice = 4
};
